
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ControlPanelCardSkeleton',
  props: {
    cardCount: {
      type: Number,
      default: 5
    }
  }
})
